import InputFilter from 'volta/components/filters/input-filter';
import SelectFilter from 'volta/components/filters/select-filter';
import SkusSupplierFilter from 'volta/components/filters/skus-supplier-filter';
import SkusWarehouseFilter from 'volta/components/filters/skus-warehouse-filter';
import SkusWorkshopFilter from 'volta/components/filters/skus-workshop-filter';
import TagsFilter from 'volta/components/filters/tags-filter';
import TokenFilter from 'volta/components/filters/token-filter';
import { beforeQueryWorkshop, clearFilter, stringListToArray } from 'volta/utils/filters-utils';

import { AcquisitionCodesOptions } from '../acquisition-codes';
import { PlanningMethodologiesOptions } from '../planning-methodologies';

import type StoreService from 'volta/services/store';
import type CustomFieldDefinitionsService from 'volta/services/custom-field-definitions-service';

export default function BomFilterDefinitions(
  store: StoreService,
  customFieldDefinitionsService: CustomFieldDefinitionsService,
  queryParamsValues: TQueryParams
): TFilterDefinition[] {
  const warehouseIds = queryParamsValues['warehouse']
    ? stringListToArray(clearFilter(queryParamsValues['warehouse']))
    : [];
  const normalDefs: TFilterDefinition[] = [
    {
      queryParam: 'warehouse',
      apiParam: 'sku.warehouseId',
      comparators: ['in', 'ni'],
      component: SkusWarehouseFilter as TBaseFilterComponent,
      componentArgs: { horizontalPosition: 'right' }
    },
    {
      queryParam: 'deliveryWorkshop',
      apiParam: 'sku.deliveryWorkshopId',
      comparators: ['in', 'ni'],
      component: SkusWorkshopFilter as TBaseFilterComponent,
      componentArgs: { beforeQuery: beforeQueryWorkshop(['DELIVERY'], queryParamsValues['warehouse']) }
    },
    {
      queryParam: 'workshop',
      apiParam: 'sku.workshopId',
      comparators: ['in', 'ni'],
      component: SkusWorkshopFilter as TBaseFilterComponent,
      componentArgs: { beforeQuery: beforeQueryWorkshop(['WORKSHOP', 'SUPPLIER', 'WORKSTATION'], queryParamsValues['warehouse']) }
    },
    {
      queryParam: 'supplier',
      apiParam: 'sku.supplierId',
      comparators: ['in', 'ni'],
      component: SkusSupplierFilter as TBaseFilterComponent,
      componentArgs: {}
    },
    {
      queryParam: 'q',
      apiParam: 'sku.q',
      comparators: ['lk'],
      component: InputFilter as TBaseFilterComponent,
      hidden: true,
      componentArgs: { inputType: 'text' }
    },
    {
      queryParam: 'acqCode',
      apiParam: 'sku.acqCode',
      comparators: ['in'],
      component: SelectFilter as TBaseFilterComponent,
      componentArgs: {
        horizontalPosition: 'right',
        possibleValues: AcquisitionCodesOptions
      }
    },
    {
      queryParam: 'methodology',
      apiParam: 'sku.methodology',
      comparators: ['in'],
      component: SelectFilter as TBaseFilterComponent,
      componentArgs: {
        horizontalPosition: 'right',
        possibleValues: PlanningMethodologiesOptions
      }
    },
    {
      queryParam: 'tags',
      apiParam: 'sku.tags',
      comparators: ['any', 'all', 'ni'],
      component: TagsFilter as TBaseFilterComponent,
      componentArgs: {
        horizontalPosition: 'right',
        entityTypes: ['skus', 'parts'],
        warehouseIds
      }
    },
    {
      queryParam: 'partsCount',
      apiParam: 'partsCount',
      comparators: ['lt', 'eq', 'gt'],
      component: InputFilter as TBaseFilterComponent,
      componentArgs: { inputType: 'number' }
    },
    {
      queryParam: 'maxLevel',
      apiParam: 'maxLevel',
      comparators: ['lt', 'eq', 'gt'],
      component: InputFilter as TBaseFilterComponent,
      componentArgs: { inputType: 'number' }
    },
    {
      queryParam: 'planner',
      apiParam: 'sku.planner',
      comparators: ['in', 'ni'],
      component: TokenFilter as TBaseFilterComponent,
      componentArgs: {
        horizontalPosition: 'left',
        warehouseIds,
        searchFn: (query: any) => {
          return store.customQuery('sku', 'planners', undefined, query);
        }
      }
    },
    {
      queryParam: 'buyer',
      apiParam: 'sku.buyer',
      comparators: ['in', 'ni'],
      component: TokenFilter as TBaseFilterComponent,
      componentArgs: {
        horizontalPosition: 'left',
        warehouseIds,
        searchFn: (query: any) => {
          return store.customQuery('sku', 'buyers', undefined, query);
        }
      }
    }
  ];

  return normalDefs.concat(customFieldDefinitionsService.skusCustomFieldsFilters('sku'));
}
